import { LiveChatThread } from 'apps/chat/constants'
import { SelectionType } from 'apps/chat/constants/LiveChatInterfaces'
import { threadActions as actions } from 'apps/chat/reducers/slices/threadListSlice'
import { getCurrentThreadItem, getThreadsSelectionType } from 'apps/chat/selectors/threadSelectors'
import { IThunkAction } from 'common/core/interfaces/actions'

export const applyChangesToThreads =
  (threadsIds: number[], changes: Partial<LiveChatThread>): IThunkAction =>
  (dispatch, getState) => {
    const currentThread = getCurrentThreadItem(getState())
    const selectionType = getThreadsSelectionType(getState())

    dispatch(
      actions.bulkUpdateItems({
        data: threadsIds.map((threadId) => ({
          id: threadId.toString(),
          item: changes,
        })),
      }),
    )

    if (currentThread && currentThread.id && threadsIds.includes(parseInt(currentThread.id, 10))) {
      dispatch(
        actions.updatedCurrentItemNotification({
          ...currentThread,
          ...changes,
        }),
      )
    }

    if (selectionType === SelectionType.EXCLUDE) {
      dispatch(actions.updateSelectionType(SelectionType.INCLUDE))
    }
  }
